var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "textArea", class: _vm.classes },
    [
      _vm.hasLabel
        ? _c(
            "label",
            { staticClass: "textArea__label" },
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.label))]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "textarea",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.valueInternal,
                expression: "valueInternal",
              },
            ],
            ref: "textarea",
            staticClass: "textArea__input",
            attrs: {
              rows: _vm.rows,
              placeholder: _vm.placeholder,
              required: _vm.required,
              readonly: _vm.readOnly,
              disabled: _vm.disabled,
            },
            domProps: { value: _vm.valueInternal },
            on: {
              blur: function ($event) {
                return _vm.$emit("blur")
              },
              focus: function ($event) {
                return _vm.$emit("focus")
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.valueInternal = $event.target.value
              },
            },
          },
          "textarea",
          _vm.filteredAttributes,
          false
        )
      ),
      _vm._v(" "),
      _vm._t("icon"),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "textArea__error" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }